import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  topNavUserInfoButton: {},
  topNavUserInfo: {
    paddingTop: 0,
    paddingBottom: 0,
    color: '#ffffff',
    textTransform: 'initial',
    textAlign: 'left',
  },
  subheader: {
    color: '#ffffff',
  },
  title: {
    color: '#ffffff',
    fontSize: 14,
    fontWeight: 500,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  menu: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  avatarInitials: {
    width: 40,
    height: 40,
    display: 'flex',
    fontSize: '1.25rem',
    alignItems: 'center',
    justifyContent: 'center',

    background: '#f5f5ed',
    borderRadius: 20,
    color: '#373252',
  },
}));
